module.exports = __webpack_public_path__ + "img/郎中乡-c.5a77f4f6.png";